import { fonts } from "./constants";

const newStyle = document.createElement("style");

// Add fonts to head style
fonts.forEach((font) => {
  const src = `url("${process.env.REACT_APP_FONTS_URL}${font.url}") format("${font.format}")`;

  newStyle.appendChild(
    document.createTextNode(
      `@font-face {
        font-family: "${font.fontFamily}";
        src: ${src};
        font-weight: ${font.fontWeight};
        font-style: ${font.fontStyle};
      }`
    )
  );
});
document.head.appendChild(newStyle);
